var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgModelType = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E869E",
    d: "M10.374 10.292v6.333l-5.542-3.958V6.333l5.542-3.958 5.541 3.958z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeLinejoin: "round",
    strokeWidth: 0.95,
    d: "M10.374 16.625v-6.333m0 6.333L5.495 13.14c-.325-.232-.487-.348-.575-.519-.088-.17-.088-.37-.088-.77V6.334m5.542 10.292 4.878-3.485c.325-.232.488-.348.576-.519.087-.17.087-.37.087-.77V6.334m-5.541 3.959L4.832 6.333m5.542 3.959 5.541-3.959m-11.083 0 4.621-3.3c.445-.318.667-.477.92-.477.254 0 .477.159.921.476l4.621 3.301"
  })));
};
export default SvgModelType;